/* eslint-disable */
var baseApiUrl = ''
var appBaseUrl = ''
if (process.env.NODE_ENV === 'production') {
  // baseApiUrl = 'https://commenting-tool-demo-api-v2.geodemosolutions.com/public/'
  // appBaseUrl = 'https://commenting-tool-demo-v2.geodemosolutions.com/#/'
  baseApiUrl = 'https://wgtp-commenting-tool-api.geodemosolutions.com/public/'
  appBaseUrl = 'https://wgtp-commenting-tool.geodemosolutions.com/#/'
 }
else {
  baseApiUrl = 'http://localhost/wgtp-commenting-tool-api/public/'
  appBaseUrl = 'http://localhost:2200/#/'
}

export {
  baseApiUrl,
  appBaseUrl
}
